import React from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./InfoContainer.module.scss";
import clsx from "clsx";

export default function(props) {
  const { 
    headerLeft, 
    headerRight, 
    footer, 
    children, 
    height = "auto", 
    classes,
    mobile
  } = props;

  // return (
  //   <div>
  //     <div className={styles.info}>
  //       <h3 className={styles.heading}>{heading}</h3>
  //       <span className={styles.count}>{count}</span>
  //     </div>
  //     <div className={styles.content}>
  //       {children}
  //     </div>
  //   </div>
  // );

  // return (
  //   <Grid
  //     container
  //     direction="column"
  //   >
  //     <Grid item>
  //       <div className={styles.info}>
  //         <h3 className={styles.heading}>{heading}</h3>
  //         <span className={styles.count}>{count}</span>
  //       </div>
  //     </Grid>
  //     <Grid item classes={{ root: styles.content }}>
  //       {children}
  //     </Grid>
  //   </Grid>
  // );

  return (
    <div 
      style={{ height: height }} 
      className={clsx(classes && classes.root)}
    >
      <Grid container direction="column" classes={{ root: styles.container }}>
        <Grid item>
          <div 
            className={clsx(
              styles.info, 
              mobile && styles.mobile,
              classes && classes.info
            )}
          >
            <h3 
              className={clsx(styles.headerLeft, classes && classes.headerLeft)}
            >
              {headerLeft}
            </h3>
            <span 
              className={clsx(styles.headerRight, classes && classes.headerRight)}
            >
              {headerRight}
            </span>
          </div>
        </Grid>
        <Grid
          item
          container
          direction="column"
          alignItems="center"
          classes={{ root: clsx(styles.content,
            classes && classes.content)}}
        >
          <Grid item classes={{ root: styles.main_content }}>
            {children}
          </Grid>
          {footer &&
          <Grid 
            item 
            classes={
              { root: clsx(
                  styles.footer, 
                  classes && classes.footer
              )}}
            >
            {footer}
          </Grid>}
        </Grid>
      </Grid>
    </div>
  );
}
